import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getNewsArticle } from "../services/publicApi";
import "../styles/DetailPages.css";
import { BACKEND_URL } from "../util/api";

const NewsDetail = () => {
    const { slug } = useParams();
    const navigate = useNavigate();

    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadArticle = async () => {
            try {
                setLoading(true);
                setError(null);

                const result =
                    await getNewsArticle(slug);

                if (result.success) {
                    setArticle(result.data);
                }
            } catch (err) {
                console.error(
                    "Failed to load news article:",
                    err
                );

                setError(
                    err.message ||
                    "Unable to load news article."
                );
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            loadArticle();
        }
    }, [slug]);

    if (loading) {
        return (
            <main className="news-detail-page">

                <div className="container news-detail-loading">
                    Loading article...
                </div>

            </main>
        );
    }

    if (error || !article) {
        return (
            <main className="news-detail-page">

                <div className="container news-detail-error">

                    <h1>
                        Article Not Found
                    </h1>

                    <p>
                        The news article you are looking
                        for could not be found.
                    </p>

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => navigate("/")}
                    >
                        Back to Home
                    </button>

                </div>

            </main>
        );
    }

    const formattedDate =
        article.published_at
            ? new Date(
                article.published_at
            ).toLocaleDateString(
                "en-NG",
                {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                }
            )
            : "";

    return (
        <main className="news-detail-page">

            {/* ARTICLE HEADER */}
            <section className="news-detail-header">

                <div className="container">

                    <button
                        type="button"
                        className="detail-back-button"
                        onClick={() => navigate(-1)}
                    >
                        ← Back  &nbsp;
                    </button>

                    <div className="news-detail-category">

                        {article.category?.name ||
                            "NEWS"}

                    </div>

                    <h1>
                        {article.title}
                    </h1>

                    <div className="news-detail-meta">

                        {formattedDate && (
                            <span>
                                {formattedDate}
                            </span>
                        )}

                        {article.location && (
                            <>
                                <span aria-hidden="true">
                                    •
                                </span>

                                <span>
                                    {article.location}
                                </span>
                            </>
                        )}

                    </div>

                </div>

            </section>

            {/* COVER IMAGE */}
            {article.cover_image && (
                <section className="news-detail-cover">

                    <div className="project-detail-image"  style={{ position: "relative", backgroundImage: `url(${BACKEND_URL + "/storage/" + article.cover_image})` }}>


                    </div>

                </section>
            )}

            {/* ARTICLE */}
            <section className="news-detail-body">

                <div className="container">

                    <div className="news-detail-layout">

                        <article className="news-article">

                            {article.excerpt && (
                                <p className="news-article-lead">
                                    {article.excerpt}
                                </p>
                            )}

                            {article.content && (
                                <div
                                    className="news-article-content"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            article.content,
                                    }}
                                />
                            )}

                        </article>

                    </div>

                </div>

            </section>

            {/* FOOTER */}
            <section className="news-detail-footer">

                <div className="container">

                    <button
                        type="button"
                        className="text-link"
                        onClick={() =>
                            navigate("/news")
                        }
                    >
                        ← View All News
                    </button>

                </div>

            </section>

        </main>
    );
};

export default NewsDetail;